/*
Copyright 2022 Alexandra Instituttet

Der er givet en begrænset licens af denne software til GEO. Licensen
giver dem ret til at benytte, videreudvikle og fejlrette udelukkende
med henblik på brug i GeoAtlasStudy web-applikationen.
*/
import React, { useEffect, useRef } from "react";
import { WgApp } from "./WgApp.js";

function WgAppComponent(props) {
  // HTML canvas reference needed by the WgApp.
  const canvasRef = React.createRef();
  let app = useRef();

  // Setup of the webGL app done on load?
  useEffect(() => {
    if (!app.current) {
      let top = canvasRef.current.getBoundingClientRect().top;
      canvasRef.current.width = window.innerWidth;
      canvasRef.current.height = window.innerHeight - top;

      app.current = new WgApp(canvasRef.current);

      window.addEventListener("resize", () => {
        app.current.resize(window.innerWidth, window.innerHeight - top);
      });
    }
  }, [canvasRef]);

  useEffect(() => {
    if (app.current) {
      app.current.setHeightScale(0.1 * props.heightScale);
      app.current.setBoreholesEnabled(props.boreholesEnabled);
      app.current.setBuildingsEnabled(props.buildingsEnabled);
      app.current.setShowOverlayTexture(props.mapEnabled);
      app.current.setClipAxis(parseInt(props.clipAxis));
    }
  }, [
    props.heightScale,
    props.buildingsEnabled,
    props.mapEnabled,
    props.boreholesEnabled,
    props.clipAxis,
  ]);

  useEffect(() => {
    if (app.current) {
      app.current.setClipPolygonEnabled(props.clipPolygonEnabled);
    }
  }, [props.clipPolygonEnabled]);

  // Render the application.
  return (
    <div>
      <canvas ref={canvasRef} />
    </div>
  );
}

export default WgAppComponent;
